import { getPaymentStatusKey } from './appointmentStatusUtils';

const ONLINE_METHOD = 'Online';
const COLLECTED_KEYS = new Set(['paid', 'depositPaid']);

/** True when money for this appointment was taken online and is still held by the store. */
export const hasCollectedOnlinePayment = (appointment) => {
  if (!appointment || !COLLECTED_KEYS.has(getPaymentStatusKey(appointment.paymentStatus))) {
    return false;
  }

  const isOnline = (method) => method === ONLINE_METHOD || method === 6;
  return isOnline(appointment.storePaymentMethod)
    || (appointment.payments || []).some((payment) => isOnline(payment?.paymentMethod))
    || Number(appointment.onlinePrepaidAmount || 0) > 0;
};

/**
 * A store-side cancellation refunds an online payment in full, fee included; a no-show keeps it.
 * Staff need to know which before they confirm.
 */
export const resolveStaffStatusMessageKey = (actionType, appointment) => {
  const paidOnline = hasCollectedOnlinePayment(appointment);

  if (actionType === 'cancel') {
    return paidOnline ? 'managementAppointments.confirm.cancelPaidOnlineMessage' : 'managementAppointments.confirm.cancelMessage';
  }

  if (actionType === 'noShow') {
    return paidOnline ? 'managementAppointments.confirm.noShowPaidOnlineMessage' : 'managementAppointments.confirm.noShowMessage';
  }

  return null;
};
